import type { GalleryMedia, MediaSize } from '@travel/ui/components/Gallery';

type GalleryMediaWithGrid = GalleryMedia & { gridType?: string };

export const CATEGORY_ALL = 'All';
export const CATEGORY_OVERVIEW = 'Overview';

export const removeGridType = (media: GalleryMediaWithGrid) => {
  const mediaWithoutGridType = media;
  delete mediaWithoutGridType.gridType;
  return media;
};

export const getImageType = (size?: MediaSize) => {
  if (!size?.width || !size.height || size.width >= size.height) {
    return 'wide';
  } else {
    return 'tall';
  }
};

export const getFilterData = (galleryData: GalleryMedia[]) => {
  const filterList = new Set();
  filterList.add(CATEGORY_ALL);
  galleryData.map((media) => {
    media.category && filterList.add(media.category);
    return media;
  });
  return Array.from(filterList) as string[];
};

export const getLayoutType = (first?: string, second?: string, third?: string) => {
  // 1 = wide, 2 = tall
  let layoutType = '';
  if (first === 'wide') {
    layoutType += '1';
  } else {
    layoutType += '2';
  }
  if (second === 'wide') {
    layoutType += '1';
  } else {
    layoutType += '2';
  }
  if (third === 'wide') {
    layoutType += '1';
  } else {
    layoutType += '2';
  }

  return layoutType;
};

export const getGridAutoLayout = (galleryData: GalleryMediaWithGrid[]) => {
  const length = galleryData.length;
  for (let i = 1; i < length; i += 3) {
    // 3 as a set
    if (i === length - 2) {
      // remaining 2
      if (galleryData[i].gridType === 'wide') {
        galleryData[i].gridType = 'small';
      }
      if (galleryData[i + 1].gridType === 'wide') {
        galleryData[i + 1].gridType = 'small';
      }
    } else if (i === length - 1) {
      // remaining 1
      if (galleryData[i].gridType === 'wide') {
        galleryData[i].gridType = 'large';
      }
      if (galleryData[i].gridType === 'tall') {
        galleryData[i].gridType = 'largeTall';
      }
    } else {
      const layoutType = getLayoutType(
        galleryData[i].gridType,
        galleryData[i + 1].gridType,
        galleryData[i + 2].gridType,
      );

      // 1 = wide, 2 = tall
      // layout design by feature mapping : https://miro.com/app/board/uXjVPlXtCkA=/
      switch (layoutType) {
        case '111':
          galleryData[i].gridType = 'small';
          galleryData[i + 1].gridType = 'small';
          galleryData[i + 2].gridType = 'large';
          break;
        case '112':
          galleryData[i].gridType = 'small';
          galleryData[i + 1].gridType = 'small';
          galleryData[i + 2].gridType = 'largeTall';
          break;
        case '121':
          galleryData[i].gridType = 'small';
          galleryData[i + 2].gridType = 'small';
          break;
        case '211':
          galleryData[i + 1].gridType = 'small';
          galleryData[i + 2].gridType = 'small';
          break;
        case '221':
          galleryData[i + 2].gridType = 'large';
          break;
        case '122':
          galleryData[i].gridType = 'large';
          break;
        case '212':
          galleryData[i].gridType = 'largeTall';
          galleryData[i + 1].gridType = 'large';
          galleryData[i + 2].gridType = 'largeTall';
          break;
        case '222':
          galleryData[i + 2].gridType = 'largeTall';
          break;
        default:
          break;
      }
    }
  }
  return galleryData;
};
